import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/Warning.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2aadb478"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "configuration-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "Transmision_title" }, "Configuración", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-style" }, " Selecciona los parámetros sobre los cuales se llevarán a cabo las validaciones que deseas que hagamos al momento de procesar tu transmisión de nómina. Ten presente que, basándonos en estas validaciones, se enviará la información a la DIAN. ", -1))
const _hoisted_4 = { class: "categorias-container" }
const _hoisted_5 = { class: "reglas-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icono",
  width: "60",
  height: "60",
  style: {"margin-right":"25px"}
}, null, -1))
const _hoisted_7 = {
  class: "gray-text",
  style: {"text-align":"justify"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Warning",
  width: "60",
  height: "60"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " No se identificaron cambios. Para realizar el guardado, debes marcar o desmarcar al menos una de las reglas. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.cargando && _ctx.categoriasConReglas.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriasConReglas, (categoria) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "categoria-item",
                key: categoria.categoriaId
              }, [
                _createElementVNode("h3", null, _toDisplayString(categoria.categoriaDescripcion), 1),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.reglasPorCategoria, (regla) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "regla-item text-style",
                      key: regla.reglaId
                    }, [
                      _createVNode(_component_el_tooltip, {
                        content: regla.tooltip,
                        disabled: !regla.tooltip,
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_checkbox, {
                            inputId: regla.reglaId,
                            modelValue: regla.activo,
                            "onUpdate:modelValue": ($event: any) => ((regla.activo) = $event),
                            label: regla.reglaDescripcion,
                            onChange: 
                  (event) =>
                    _ctx.MarcarCambioDeEstado(
                      categoria.categoriaId,
                      regla.reglaId,
                      event.target.checked
                    )
                
                          }, null, 8, ["inputId", "modelValue", "onUpdate:modelValue", "label", "onChange"])
                        ]),
                        _: 2
                      }, 1032, ["content", "disabled"])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "Button_BColorDegraded Button_fontButtonError",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ValidarReglasCambiadas && _ctx.ValidarReglasCambiadas(...args)))
          }, " Guardar "),
          true
            ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
                key: 0,
                id: "confirm-dialog",
                style: {"width":"auto"},
                draggable: false
              }, {
                message: _withCtx((props) => [
                  _hoisted_6,
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(props.message.message), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.sinCambios,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sinCambios) = $event)),
      modal: "",
      closable: false,
      header: "Importante",
      draggable: false,
      id: "p-dialog",
      class: "error-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          onClick: _ctx.CerrarModal,
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("← Volver")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_8,
        _hoisted_9
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}